module.exports = __webpack_public_path__ + "img/news2.bb6b2734.jpg";